import React, { Component } from 'react';
import Select from 'react-select';
import { multiSelectDatatransform } from './helper';
import { toast } from 'react-toastify';
class MultiSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null
        }
        this.options = []
    }
 
    componentDidUpdate(prevProps) {
        if (this.props.selectedValue !== prevProps.selectedValue) {
            let data = multiSelectDatatransform(this.props.selectedValue);
            this.setState({
                selectedOption: data
            })
        }
    }

    handleChange = (selectedOption) => {
        if (this.props.id) {
            if (selectedOption.length <= 3) {
                this.setState({ selectedOption });
                this.props.selected(selectedOption)
            } else {
                toast.warn(
                    <div>
                        Maximum of three fields are allowed in Level One Key Fields
                    </div>
                );
            }
        } else {
            this.setState({ selectedOption });
            this.props.selected(selectedOption)
        }

    }

    render() {
        if (this.props.data) {
            this.options = multiSelectDatatransform(this.props.data);
        }
        const { selectedOption } = this.state;
        const tempOptions = (this.options.length > 0) ? this.options : []
        return (
            <div>
                <Select
                    value={selectedOption}
                    onChange={this.handleChange}
                    options={tempOptions}
                    isMulti={(this.props.id === 'masterDataKey') ? false : true}
                    isDisabled={this.props.isDisabled?this.props.isDisabled: false}
                />
            </div>
        );
    }
}



export default MultiSelect;

